type Event = {
    id: number;
    title: string,
    date: string,
    time: string,
    location: string,
    cost: string,
    image: string,
    archived: number,
    url_slug: string
}


export default async function loader(): Promise<Event[] | null> {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/events`)
    const events: Event[] = await response.json()
    const filteredEvents = events.filter((item)=> {
        return item.archived === 0
    })
    return filteredEvents   
}